var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8968_38571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.167 5.06369C15.9348 6.35163 17.0837 8.43791 17.0837 10.7925C17.0837 14.7045 13.9123 17.8759 10.0003 17.8759H9.58366M5.83366 16.5214C4.06588 15.2334 2.91699 13.1471 2.91699 10.7925C2.91699 6.8805 6.08831 3.70919 10.0003 3.70919H10.417M10.8337 19.4592L9.16699 17.7925L10.8337 16.1259M9.16699 5.45919L10.8337 3.79252L9.16699 2.12585",
    stroke: "#F4FBFC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8968_38571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.000366211 0.459229)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.c022f2b832ee6f9b149d028888e6f4a3.svg";
export { ForwardRef as ReactComponent };